module.exports = __webpack_public_path__ + "img/avatar0.019adb92.png";